import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { Gradient } from 'utils/types';

export const StyledDecaBundle = styled.div`
  width: 100%;
  min-height: 284px;
  height: auto;
  min-width: 168px;
  max-width: 168px;
  font-family: var(--font-family), Arial;

  .container {
    width: 100%;
    height: 240px;
    background: linear-gradient(180deg, #2e3238 0%, #212529 100%);
    border-radius: 7px;
    box-shadow: 0px 0px 4px 2px #2e3237 inset;
    margin-bottom: 4px;
    padding: 4px;
    display: flex;
    flex-direction: column;

    .mainProductContainer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 143px;
    }

    .tooltip {
      margin-bottom: 4px;
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }

    .title {
      text-align: center;
      font-size: 10px;
      color: #eceaea;
      height: 100%;
      max-height: 24px;
      min-height: 24px;
    }

    .subtitle {
      text-align: center;
      font-size: 8px;
      color: #fff;
      margin-bottom: 6px;
      height: 100%;
      max-height: 28px;
      min-height: 28px;
    }

    .subProducts {
      margin-top: auto;
      background-color: #171a1c;
      border-radius: 4px;
      padding: 4px 0 4px 4px;
      height: 62px;

      &__scroll {
        display: flex;
        align-items: center;
        overflow-y: hidden;
        overflow-x: scroll;

        /* --- WebKit (Chrome, Safari, Edge) --- */
        &::-webkit-scrollbar {
          height: 1px;
        }

        &::-webkit-scrollbar-thumb {
          background: #fff;
          border-radius: 1px;
        }
      }
    }
  }

  .price {
    position: static;

    .totalPrice {
      padding: 0 8px;
      width: 100%;

      .final-price {
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-shadow: none;
        font-size: inherit;
      }

      .stroked {
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #eceaea;
        font-size: calc(clamp(4px, 1em * 0.75, 12px));
      }
    }
  }
`;

export const StyledMainProduct = styled.div<{
  backgroundColor: Gradient;
  isMainProduct: boolean;
}>`
  text-align: center;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 80px;
  min-width: 80px;
  width: 80px;
  min-height: 80px;
  background: ${({ isMainProduct, backgroundColor }) =>
    backgroundColor && isMainProduct
      ? createGradientOrSolid(backgroundColor)
      : 'transparent'};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 6px auto;

  .backgroundSrc {
    width: 100%;
    height: 100%;
    max-height: 80px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product {
    width: 100%;
    height: 100%;
    padding: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .image {
      width: auto;
      height: 43px;
      object-fit: contain;
    }

    .traits {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      .trait {
        width: 14px;
        height: 14px;
        object-fit: contain;
        margin: 2px 4px;
      }
    }
  }
`;

export const StyledSubProduct = styled.div`
  text-align: center;
  margin-right: 12px;
  margin-bottom: 1px;

  .image {
    min-width: 36px;
    width: 36px;
    height: 36px;
    display: block;
    margin: auto;
  }

  .quantity {
    margin-top: 4px;
    max-height: 12px;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
